
import { throwStatement } from 'babel-types';
import React, { Component } from 'react';

//import Game from './game/Game';

import './../../../scss/App.scss';


class PowerPieces extends Component {

	constructor(props){
		super(props);

		this.state = {
			"active_1": true,
			"active_2": false,
			"active_3": false,
			"used_1": false,
			"used_2": false,
			"used_3": false
		}

		//


		//

		window.ppz.powerPieces = this;
	}

	componentDidMount(){

	}

	componentDidUpdate(prevProps) {

	}

	unlockAPowerPiece(){
		if(this.state.active_1 === false){
			this.setState({
				"active_1": true,
				"used_1": true 
			});
			window.ppz.crossword.handleRevealLetter();
		}
		else if(this.state.active_2 === false){
			this.setState({
				"active_2": true,
				"used_2": true  
			});
			window.ppz.crossword.handleRevealLetter();
		}
		else if(this.state.active_3 === false){
			this.setState({
				"active_3": true, 
				"used_3": true 
			});
			window.ppz.crossword.handleRevealLetter();
		}
	}
	
	handlePowerPiece(number){
		let active = "active_" + number;
		let used = "used_" + number;

		if(this.state[active] === true){
			window.ppz.crossword.handleRevealLetter();

			this.setState({
				[used]: true 
			});
		}
		else{
			window.ppz.overlayManager.setPanel("powerPieces");
		}
		
	}

	renderPowerPieces(){
		let classes_1 = "";
		let	classes_2 = "";
		let classes_3 = "";

		if(this.state.used_1){
			classes_1 = " used";
		}
		else if(this.state.active_1){
			classes_1 = "active";
		}

		if(this.state.used_2){
			classes_2 = " used";
		}
		else if(this.state.active_2){
			classes_2 = "active";
		}

		if(this.state.used_3){
			classes_3 = " used";
		}
		else if(this.state.active_3){
			classes_3 = "active";
		}

		return (
			<div>
				<div className={"powerPiece " + classes_1} onClick={() => this.handlePowerPiece("1")}>
					<div className="slash"></div>
					<div className="number">1</div>
					Abc
				</div>
				<div className={"powerPiece " + classes_2} onClick={() => this.handlePowerPiece("2")}>
					<div className="slash"></div>
					<div className="number">2</div>
					Abc
				</div>
				<div className={"powerPiece " + classes_3} onClick={() => this.handlePowerPiece("3")}>
					<div className="slash"></div>
					<div className="number">3</div>
					Abc
				</div>
			</div>
		);
	}

	render(){
		let hasWonStyle = "";
		if(this.props.hasWon){
			hasWonStyle = " disable";
		}

		return (
			<div className={"powerPieces" + hasWonStyle}>
				<div className="toolTip">A Power Piece will randomly select a letter to help you along the way</div>
				<div className="label">Power Pieces</div>
				{this.renderPowerPieces()}
			</div>
		);
	}
}

export default PowerPieces;


// WEBPACK FOOTER //
// ./src/js/components/gamepage/PowerPieces.js